import { InlineIcon } from "@iconify/react";
import { useEffect, useState } from "react";
import { ColorPickerModal } from "./ColorPickerModal";
import { LogoPickerModal } from "./LogoPickerModal";
import type { SubagentData } from "./types";

type LogoAndColorsProps = {
  subagentData: SubagentData;
  appUserDataQueryKey: (string | undefined)[];
};

export function LogoAndColors({ subagentData, appUserDataQueryKey }: LogoAndColorsProps) {
  const [isColorModalOpen, setIsColorModalOpen] = useState(false);
  const [isLogoModalOpen, setIsLogoModalOpen] = useState(false);
  const [localColors, setLocalColors] = useState({
    primaryColor: subagentData.entity_colors?.base || "#000000",
    secondaryColor: subagentData.entity_colors?.background.secondary?.dark || "#000000",
  });

  // Update local colors when subagentData changes
  useEffect(() => {
    setLocalColors({
      primaryColor: subagentData.entity_colors?.base || "#000000",
      secondaryColor: subagentData.entity_colors?.background.secondary?.dark || "#000000",
    });
  }, [subagentData.entity_colors]);

  const handleSaveColors = (colors: { primaryColor: string; secondaryColor: string }) => {
    setLocalColors(colors);
  };

  return (
    <>
      <div className="LogoAndColors grid gap-3 p-3 bg-[#F9F9F9] rounded-sm">
        <div className="grid grid-cols-[1fr_auto_auto] items-center mb-3">
          <div className="text-lg font-medium">Logo & Colors</div>
          <button
            type="button"
            onClick={() => setIsColorModalOpen(true)}
            className="grid grid-flow-col items-center gap-2 px-3 py-1 text-sm font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-sm transition-colors"
          >
            <InlineIcon icon="mdi:pencil" className="text-base" />
            Edit Colors
          </button>
          <button
            type="button"
            onClick={() => setIsLogoModalOpen(true)}
            className="grid grid-flow-col items-center gap-2 px-3 py-1 text-sm font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-sm transition-colors w-fit"
          >
            <InlineIcon icon="mdi:pencil" className="text-base" />
            Edit Logo
          </button>
        </div>

        <img
          src={subagentData.logo_url}
          alt="Subagent Logo"
          className="w-full max-w-[200px] h-auto"
        />
        <div className="grid gap-3">
          <div className="grid grid-cols-[auto_1fr] gap-3 items-center">
            <div
              className="w-12 h-12 rounded-sm border border-[#ddd]"
              style={{ backgroundColor: localColors.primaryColor }}
            />
            <div className="text-base font-medium">Primary Color</div>
          </div>
          <div className="grid grid-cols-[auto_1fr] gap-3 items-center">
            <div
              className="w-12 h-12 rounded-sm border border-[#ddd]"
              style={{ backgroundColor: localColors.secondaryColor }}
            />
            <div className="text-base font-medium">Secondary Color</div>
          </div>
        </div>
      </div>
      {isColorModalOpen && (
        <ColorPickerModal
          onClose={() => setIsColorModalOpen(false)}
          subagentData={subagentData}
          appUserDataQueryKey={appUserDataQueryKey}
          onSave={handleSaveColors}
        />
      )}
      {isLogoModalOpen && (
        <LogoPickerModal
          onClose={() => setIsLogoModalOpen(false)}
          logo_url={subagentData.logo_url}
          appUserDataQueryKey={appUserDataQueryKey}
        />
      )}
    </>
  );
}
